




import { mapGetters } from "vuex";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  computed: {
    ...mapGetters("auth", { isAuthenticated: "isAuthenticated" }),
    ...mapGetters("billing", {
      isSubscriptionExpired: "isSubscriptionExpired",
    }),
    ...mapGetters("transactions", {
      hasPastTransactions: "hasPastTransactions",
    }),
  },
})
export default class MainApp extends Vue {
  @Watch("isAuthenticated")
  handleLoginEvents(isAuthenticated: boolean): void {
    if (isAuthenticated) {
      this.$router.replace("/");
    } else {
      this.$router.replace("/login");
    }
  }
  @Watch("hasPastTransactions")
  handlePastTransactions(hasPastTransactions: boolean): void {
    if (hasPastTransactions) {
      this.$router.replace("/reschedule");
    } else {
      this.$router.replace("/");
    }
  }

  @Watch("isSubscriptionExpired")
  handleSubscriptionExpired(isSubscriptionExpired: boolean): void {
    if (isSubscriptionExpired) {
      this.$router.replace({ name: "Settings.Billing" });
    }
  }
}
